import React from 'react';
import { Link } from 'react-router-dom';
import { EyeIcon } from '../../../../../../utils/SVGIcon';
import { GetDate } from '../../../../../../utils/Show';
import { mkRelativeUrl } from '../../../../../../utils/URL';
import cn from '../../../../../../utils/cn';

function CustomerTicketTr({ item }) {
    return (
        <tr
            className={cn(`group`, {
                'placeholder-mode': item?.demo
            })}
            // onClick={handleAppInfoModal}
        >
            <td>
                <span>{item?.id}</span>
            </td>
            <td className="cursor-pointer group-hover:text-secondary hover:underline">
                <Link
                    to={`/agency/${item?.agencyId}/customers/${item?.id}/info`}
                    className="block w-full"
                >
                    <span className="text-ellipsis overflow-hidden w-full block first-letter:!uppercase group-hover:font-medium capitalize">
                        {item?.organization || '-----'}
                    </span>
                </Link>
            </td>
            <td className="">
                <span>{item?.primaryEmail}</span>
            </td>
            <td className="text-center hidden xl:table-cell">N/A</td>
            <td>
                <span>{GetDate(item?.timeCreated) || '-----'}</span>
            </td>
            <td className="text-center">
                <span>{item?.currency}</span>
            </td>
            <td className="text-center">
                <span className={item?.tfaEnabled ? 'text-secondary' : 'text-error'}>
                    {item?.tfaEnabled ? 'Enabled' : 'Disabled'}
                </span>
            </td>
            <td
                className={cn('text-center capitalize', {
                    '*:text-success': item?.status === 'open',
                    '*:text-error': item?.status === 'closed'
                })}
            >
                <span>{item?.status}</span>
            </td>

            <td className="text-center">
                <span>
                    <Link
                        type="button"
                        to={mkRelativeUrl(`/agency/${item?.agencyId}/customer/${item?.id}/info`)}
                        data-tooltip-id="myToolTip"
                        data-tooltip-content="View Info"
                        className="inline-block size-[31px] p-[5px] rounded-[7px] text-secondary-700 hover:text-secondary"
                    >
                        <EyeIcon />
                    </Link>
                </span>
            </td>
        </tr>
    );
}

function CustomerTableHeader() {
    return (
        <thead>
            <tr>
                <th scope="col">
                    <span>ID</span>
                </th>
                <th scope="col" className="w-42">
                    <span>Org. Name</span>
                </th>
                <th scope="col" className="w-42">
                    <span>Email</span>
                </th>
                <th scope="col" className="text-center">
                    <span>Application</span>
                </th>
                <th scope="col" className="w-30 text-center hidden xl:table-cell">
                    <span>Date Created</span>
                </th>
                <th scope="col" className="w-30 text-center">
                    <span>Currency</span>
                </th>
                <th scope="col" className="w-30 text-center">
                    <span>2FA</span>
                </th>
                <th scope="col" className="w-30 text-center">
                    <span>Status</span>
                </th>
                <th scope="col">#</th>
            </tr>
        </thead>
    );
}
function TableWeb({ data }) {
    return (
        <div className="agency_customer_table pb-40 overflow-x-auto">
            <table className="bik-table" cellPadding={0} cellSpacing={0}>
                <CustomerTableHeader />
                <tbody>
                    {data && data?.customers?.length === 0 ? (
                        <tr className="hover:!bg-inherit">
                            <td colSpan={9} className="!text-left">
                                No Customer Found!
                            </td>
                        </tr>
                    ) : (
                        data?.customers?.map((item) => (
                            <CustomerTicketTr key={item.id} item={item} />
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
}

export default TableWeb;
